export const DROP_ZONE_ARIA_LABEL_PREFIX = 'Drop zone '
export const DROP_ZONE_KEY_PREFIX = 'dropZone'
